import get from 'lodash/get';

import {
  CLEAR_PERSON_ACTIONS_LOG,
  GET_ACTIONS_LOG_FAILURE,
  GET_ACTIONS_LOG_NAMES_FAILURE,
  GET_ACTIONS_LOG_NAMES_REQUEST,
  GET_ACTIONS_LOG_NAMES_SUCCESS,
  GET_ACTIONS_LOG_REQUEST,
  GET_ACTIONS_LOG_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_PERSON_ACTIONS_LOG_FAILURE,
  GET_PERSON_ACTIONS_LOG_REQUEST,
  GET_PERSON_ACTIONS_LOG_SUCCESS,
  SET_LIST_PARAMS,
} from '../../../actionConstants';

import apiClient from '../../../apiClient';

export const setActionsLogListParams = (dispatch, queryParams) =>
  dispatch({
    type: SET_LIST_PARAMS,
    listKey: 'ActionsLog',
    queryParams,
  });

export const getActionsLog = (dispatch, queryParams, isExport) =>
  dispatch({
    type: GET_ACTIONS_LOG_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.carsonActivity.getActionsLog(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_ACTIONS_LOG_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_ACTIONS_LOG_FAILURE,
          err,
        }),
    ),
  });

export const getLiveStreamItems = (dispatch, queryParams, items, isOnHold) => {
  const prevItemsCount = get(items, 'count');
  return dispatch({
    type: 'GET_ACTIONS_LOG_LIVE_REQUEST',
    withoutLoading: true,
    payload: apiClient.carsonActivity
      .getActionsLog({ limit: queryParams.limit })
      .then(
        (res) => {
          dispatch({ type: 'GET_ACTIONS_LOG_LIVE_SUCCESS' });
          const newItemsCount = get(res, 'data.count');
          if (newItemsCount !== prevItemsCount && !isOnHold) {
            dispatch({
              type: GET_ACTIONS_LOG_SUCCESS,
              res,
            });
            return newItemsCount;
          }
          if (newItemsCount !== prevItemsCount && isOnHold) {
            return newItemsCount;
          }
          return newItemsCount;
        },
        (err) =>
          dispatch({
            type: 'GET_ACTIONS_LOG_LIVE_FAILURE',
            err,
          }),
      ),
  });
};

export const getActionsLogNames = (dispatch) =>
  dispatch({
    type: GET_ACTIONS_LOG_NAMES_REQUEST,
    payload: apiClient.carsonActivity.getActionsLogNames().then(
      (res) =>
        dispatch({
          type: GET_ACTIONS_LOG_NAMES_SUCCESS,
          res: get(res, 'data.actions', []),
        }),
      (err) =>
        dispatch({
          type: GET_ACTIONS_LOG_NAMES_FAILURE,
          err,
        }),
    ),
  });

export const getPersonActionsLog = (dispatch, queryParams, personId) =>
  dispatch({
    type: GET_PERSON_ACTIONS_LOG_REQUEST,
    payload: apiClient.carsonActivity
      .getPersonActionsLog(personId, queryParams)
      .then(
        (res) =>
          dispatch({
            type: GET_PERSON_ACTIONS_LOG_SUCCESS,
            res,
            personId,
          }),
        (err) =>
          dispatch({
            type: GET_PERSON_ACTIONS_LOG_FAILURE,
            err,
          }),
      ),
  });

export const clearPersonActionsLog = (dispatch) =>
  dispatch({
    type: CLEAR_PERSON_ACTIONS_LOG,
  });
